import {
  createFluidLight,
  FluidLightConfig,
  FluidLightShader,
  FluidLightEchoConfig,
  FluidLightLightWaveConfig,
} from "./shaders/fluid-light";
import { attachFluidLightDevtools } from "../devtools/panels/fluid-light";
import { ShaderDefinition, DevtoolsInstance } from "./base-shader";

const fluidLightDefinition: ShaderDefinition<
  FluidLightConfig,
  FluidLightShader
> = {
  create: createFluidLight,
  attachDevtools: attachFluidLightDevtools,
};

export const FluidLight = fluidLightDefinition;

export type {
  FluidLightConfig,
  FluidLightShader,
  FluidLightEchoConfig,
  FluidLightLightWaveConfig,
  DevtoolsInstance,
};
